import React from 'react';
import { FormattedTime } from 'react-intl';
import { useLocalizationContext } from '../LocalizationProvider';
import toDateTime from '../util/toDateTime';

export const Time = ({ date, hideTimeZone = false, testId }) => {
  const { timeZone } = useLocalizationContext();

  const options = {
    hour: '2-digit',
    minute: '2-digit',
    timeZone,
  };

  const dateTime = React.useMemo(() => toDateTime(date, timeZone), [date, timeZone]);

  const tz = React.useMemo(() => {
    if (!dateTime) return null;
    return dateTime?.toFormat?.('ZZZZ');
  }, [dateTime]);

  if (!date) return null;

  return (
    <span data-testid={testId}>
      <FormattedTime value={dateTime} {...options} />
      {hideTimeZone ? '' : ` (${tz})`}
    </span>
  );
};
